import { PriceItem } from '@/entities/catalog-inside-page/PriceItem/ui/PriceItem'
import './ui/PriceItem.css'
export default PriceItem
